/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Define all table the color constants, font families and primary colors here
 */
export const PRIMARY_COLOR = '#2B3FD2';
//
export const PAGE_BACKGROUND_COLOR = '#FBFBFE';
//
export const FONT_FAMILY = 'Lexend, Tahoma, Geneva, Verdana, sans-serif';
//
export const TABLE_HEADER_COLOR = 'rgba(176, 196, 232)';
//
export const TABLE_SELECT_CELL_COLOR = 'rgba(217, 226, 244, 1)';
//
export const TABLE_HEADER_FONT_COLOR = 'black';
